import React, { useState, useContext } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Form, Button } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import ReCAPTCHA from 'react-google-recaptcha'

import { AuthContext } from '../contexts/AuthContext'
import Footer from '../components/Footer/Footer'
import {
  REGISTER_PATH,
  FORGOTTEN_PASSWORD_REQUEST_PATH,
  HOME_PATH,
  LOGIN_PATH,
} from '../config/routes'
import config from '../config/config'
import { useWebsite, setFlashMessage } from '../contexts/WebsiteContext'
import DisplayMessage from '../components/DisplayMessage'
import PageHeroTitle from '../components/PageHeroTitle'
import NavigationBar from '../components/NavigationBar'
import BottomImage from '../components/BottomImage'

const Login = () => {
  const { t } = useTranslation()
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [captchaToken, setCaptchaToken] = useState('')
  const [isCaptchaError, setIsCaptchaError] = useState(false)
  const navigate = useNavigate()

  const { handleLogin, handleLogout, lastVisitedPage } = useContext(AuthContext)
  const pageName = 'LOGIN'

  const handleCaptchaChange = (token) => {
    setCaptchaToken(token)
  }

  const handlePostLogin = async (e) => {
    e.preventDefault()
    window.scrollTo(0, 0)

    if (!captchaToken) {
      setIsCaptchaError(true)
      return
    }
    setIsCaptchaError(false)

    try {
      const response = await fetch(`${config.apiUrl}login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: username,
          password: password,
        }),
      })

      if (response.ok) {
        const data = await response.json()
        handleLogin(data)
        navigate(lastVisitedPage || HOME_PATH)
      } else {
        setFlashMessage(t('LOGIN_INVALID_CREDENTIALS'), 'error')
        handleLogout(LOGIN_PATH)
      }
    } catch (error) {
      setFlashMessage(t('ERROR_MESSAGE'), 'error')
      console.error('An error occurred POST login ', error)
    }
  }

  return (
    <div>
      <NavigationBar />

      <PageHeroTitle title={t('LOGIN_LOGIN')} description="" />

      <div
        className="block-wrapper mt-4"
        style={{ maxWidth: '600px', margin: 'auto' }}
      >
        <Form onSubmit={handlePostLogin}>
          <Form.Group controlId="formBasicUsername">
            <Form.Label>{t('LOGIN_EMAIL')}</Form.Label>
            <Form.Control
              type="email"
              placeholder={t('LOGIN_EMAIL_PLACEHOLDER')}
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          </Form.Group>

          <Form.Group
            controlId="formBasicPassword"
            style={{ marginTop: '20px' }}
          >
            <Form.Label>{t('LOGIN_PASSWORD')}</Form.Label>
            <Form.Control
              type="password"
              placeholder={t('LOGIN_PASSWORD_PLACEHOLDER')}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </Form.Group>

          <div className="text-center m-3" style={{ paddingBottom: '30px' }}>
            <div style={{ margin: '20px auto', width: '300px' }}>
              {isCaptchaError && (
                <DisplayMessage
                  messageType="error"
                  message={t('CAPTCHA_ERROR')}
                />
              )}
              <ReCAPTCHA
                sitekey={config.recaptchaKey}
                onChange={handleCaptchaChange}
              />
            </div>

            <Button variant="primary" type="submit">
              {t('LOGIN_LOGIN')}
            </Button>
            <Link to={REGISTER_PATH} className="btn btn-secondary m-3">
              {t('LOGIN_REGISTER')}
            </Link>
          </div>

          <div style={{ textAlign: 'center', marginBottom: '10px' }}>
            <Link
              to={FORGOTTEN_PASSWORD_REQUEST_PATH}
              className="btn-link forgot-password-link"
            >
              {t('FORGOTTEN_PASSWORD_REQUEST_TITLE')}
            </Link>
          </div>
        </Form>
      </div>

      <Footer />
    </div>
  )
}

export default Login
